import { render } from "./ArchiveAppeals.vue?vue&type=template&id=5077c0ef"
import script from "./ArchiveAppeals.vue?vue&type=script&lang=js"
export * from "./ArchiveAppeals.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__